import React from 'react'
import './Dropdown.css'

class Dropdown extends React.Component {
  state = {
    expanded: false,
    value: this.props.value || this.props.options[0].value,
  }

  componentDidUpdate(props, state) {
    if(props.value !== this.props.value) {
      this.setState({ value: this.props.value })
    }
  }

  get hasOneOption() {
    return this.props.options.filter(item => !item.disabled).length < 2
  }

  handleToggle = e => {
    if(!this.hasOneOption) {
      this.setState(prevState => ({ expanded: !prevState.expanded }))
    }
  }

  handleSelect = value => {
    this.setState({
      value: value,
      expanded: false,
    }, () => {
      this.props.onChange(this.state.value)
    })
  }

  render() {
    const getCurrentLabel = this.props.options.find(item => item.value === this.state.value).label

    return (
      <div className={`Dropdown${this.state.expanded ? ' is-active' : ''}${this.hasOneOption ? ' has-one-option' : ''}`} style={this.props.style}>
        <div className={`Dropdown-select`} onClick={this.handleToggle}>
          <div className="Dropdown-select-label">
            <label>{this.props.label}</label>
          </div>
          <div className="Dropdown-select-value">
            {getCurrentLabel}
          </div>
          {!this.hasOneOption &&
            <div className="Dropdown-select-icon">
              <i className={`sh-icon sh-icon-${this.state.expanded ? 'arrow-up' : 'arrow-down'}`} />
            </div>
          }
        </div>

        {this.state.expanded &&
          <div className="Dropdown-content">
          {this.props.options.map(item => (
            <a key={item.value}
              onClick={() => this.handleSelect(item.value)}
              className={`${this.state.value === item.value ? 'active' : ''}${item.disabled ? ' disabled' : ''}`}>
              {item.label}
            </a>
          ))}
          </div>
        }
      </div>
    )
  }
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/content/components/dropdown/Dropdown.js